import angular from 'angular'
import { apiKeyTypes } from '.'

export function APIKeyCtrl(
  $scope,
  $translate,
  $routeParams,
  permissions,
  logger,
  ProfileService,
  rotateKeyModalService,
  keysManagementService,
  keyStatusService,
  apiAuthorizationService
) {
  'ngInject'

  let _isEdit

  angular.extend($scope, {
    model: {
      organization: {
        id: $routeParams.orgUuid,
        name: '',
        isSuperadminOrg: false
      },
      userID: '',
      apiKeyData: apiAuthorizationService.getInitialData()
    },
    apiKeyStatus: {
      rotated: false
    },
    agentKeyStatus: {
      rotated: false
    }
  })

  angular.extend($scope, {
    rotateAgentServiceKey,
    rotateAPIKey,
    copyAPIRequest,
    getMostPermissiveRole
  })

  init()

  function init() {
    $scope.model.userID = ProfileService.getUid()
    _isEdit = permissions.hasEnterprisePermission('EDIT') // false with an Org has no licenses and at least 1 app onboarded
    _getAgentKeys()

    if (!permissions.isImpersonating()) {
      _getApiKeyData()
    }
  }

  function _getApiKeyData() {
    return apiAuthorizationService
      .init()
      .then(({ apiKey, authHeader, teamserverURL }) => {
        $scope.model.apiKeyData.apiKey = apiKey
        $scope.model.apiKeyData.authHeader = authHeader
        $scope.model.apiKeyData.teamserverURL = teamserverURL
      })
  }

  function _getAgentKeys() {
    if (_isEdit) {
      return keysManagementService.getAgentKeys().then((response) => {
        $scope.model.token = response.token
        $scope.model.agentServiceKey = response.service_key
        $scope.model.agentUsername = response.user_uid
      })
    }
  }

  function rotateAPIKey() {
    rotateKeyModalService.openRotateKeyModal(apiKeyTypes.API_KEY).then(() => {
      return keysManagementService.rotateAPIKey().then((response) => {
        logger.logSuccess(response.messages[0], { timeOut: 3500 })

        _getApiKeyData().then(() => {
          keyStatusService.changeKeyStatusToRotated($scope.apiKeyStatus)
        })
      })
    })
  }

  function rotateAgentServiceKey() {
    rotateKeyModalService
      .openRotateKeyModal(apiKeyTypes.AGENT_USER_SERVICE_KEY)
      .then(() => {
        return keysManagementService
          .rotateAgentServiceKey()
          .then((response) => {
            logger.logSuccess(response.messages[0])

            _getAgentKeys().then(() => {
              keyStatusService.changeKeyStatusToRotated($scope.agentKeyStatus)
            })
          })
      })
  }

  function copyAPIRequest() {
    logger.logSuccess($translate.instant('detail_sampleAPIRequestCopied'))
  }

  function getMostPermissiveRole() {
    return permissions.getMostPermissiveRole()
  }
}
